// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__6-+XP","title":"style_title__PghC+","form":"style_form__YuSwM","input":"style_input__dS6Zo","btn":"style_btn__lDmdt"};